import mifosRepository, { MifosRepository } from "./MifosRepository";

const APPLICATION_JSON = "application/json";
const resourceClients = "/clients";
const resourceClient = "/client";
export default {

  getClient(clientId) {
    mifosRepository.setContentType(APPLICATION_JSON);
    return MifosRepository.get(`${resourceClients}/${clientId}`);
  },

  createClient(clientPayload) {
    mifosRepository.setContentType(APPLICATION_JSON);
    return MifosRepository.post(`${resourceClients}`, clientPayload);
  },

  updateClient(clientId, clientPayload) {
    mifosRepository.setContentType(APPLICATION_JSON);
    return MifosRepository.put(`${resourceClients}/${clientId}`, clientPayload);
  },

  uploadClientImage(clientId, name, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('name', name);
      mifosRepository.setContentType("multipart/form-data");
      MifosRepository.post(`${resourceClients}/${clientId}/images`, formData)
        .then(res => {
          resolve(res)
        }).catch(err => {
        reject(err)
      })
    })
  },

  getAddressTemplates() {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceClient}/addresses/template`)
  },

  getClientAddress(clientId, status, addressType) {
    const httpParams = {
      status: status,
      type: addressType
    };
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceClient}/${clientId}/addresses`, { params: httpParams })
  },

  saveClientAddress(clientId, addressTypeId, address) {
    // const httpParams = {
    //   type: addressTypeId
    // };
    const queryParam = "?type=" + addressTypeId;

    mifosRepository.setContentType("application/json");
    return MifosRepository.post(`${resourceClient}/${clientId}/addresses${queryParam}`, address)
  },

  updateClientAddress(clientId, addressTypeId, address) {
    // const httpParams = {
    //   type: addressTypeId
    // };
    const queryParam = "?type=" + addressTypeId;

    mifosRepository.setContentType("application/json");
    return MifosRepository.put(`${resourceClient}/${clientId}/addresses${queryParam}`, address)
  },

  getClientTemplate() {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceClients}/template`);
  },

  getClientIdentifierTemplate(clientId) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceClients}/${clientId}/identifiers/template`)
  },

  getClientIdentifiers(clientId) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceClients}/${clientId}/identifiers`)
  },

  getClientImage(clientId, documentId) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceClients}/${clientId}/documents/${documentId}/attachment`)
  },

  createClientIdentifier(clientId, identifierPayload) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.post(`${resourceClients}/${clientId}/identifiers`, identifierPayload)
  },

  getClientAccounts(entityId) {
    mifosRepository.setContentType(APPLICATION_JSON);
    return MifosRepository.get(`${resourceClients}/${entityId}/accounts`);
  },

};
